import React from "react";
import { Helmet } from "react-helmet";

function Library() {
  return (
		<>
			<Helmet>
				<title>Library | University of Education</title>
			</Helmet>
			<div className="PageContainer">
				<div className="Campus">
					<div className="BannerImg HeaderImg">
						<img src="/Images/Campus/Dept/lib.jpg" alt="banenr-img" />
					</div>

					<div id="Heading">
						<h1>Library</h1>
					</div>

					<div className="Desc">
						<div className="DescParagraph">
							<p>
								A college library is a place where students, faculty, and staff
								can go to access a variety of resources, including books,
								journals, magazines, newspapers, electronic databases, and
								multimedia materials. It is also a place where people can go to
								study, collaborate, and conduct research.
								<br />
								<br />
								College libraries are an important resource for students,
								faculty, and staff. They provide access to a wide range of
								resources and services that can help people with their academic,
								professional, and personal goals.
							</p>
						</div>
						<div className="DescImg">
							<img src="/Images/Campus/Dept/library-1.jpeg" alt="img1" />
						</div>
					</div>

					<div className="LibraryDetailsSection" style={{ padding: "1rem 1rem 3rem 1rem", maxWidth: "900px", margin: "0 auto" }}>
						<div id="Secondary_Heading">
							<h3 style={{ textAlign: "center", marginBottom: "1.5rem" }}>Details of the Books and journals – ITEP</h3>
						</div>
						<div className="CourseTable" style={{ marginBottom: "3rem" }}>
							<table>
								<thead>
									<tr>
										<th style={{ textAlign: "center", fontWeight: "bold" }}>S.No.</th>
										<th style={{ fontWeight: "bold" }}>Item</th>
										<th style={{ textAlign: "center", fontWeight: "bold" }}>Numbers</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td style={{ textAlign: "center" }}>1</td>
										<td>Total Books</td>
										<td style={{ textAlign: "center" }}>4946</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>2</td>
										<td>Title</td>
										<td style={{ textAlign: "center" }}>578</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>3</td>
										<td>Total Periodical</td>
										<td style={{ textAlign: "center" }}>21</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>3.1</td>
										<td>National Journals in hard copy</td>
										<td style={{ textAlign: "center" }}>19</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>3.2</td>
										<td>International journals in hard copy</td>
										<td style={{ textAlign: "center" }}>01</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>4</td>
										<td>Total E-journals</td>
										<td style={{ textAlign: "center" }}>Institution subscribes ONOS Subscription</td>
									</tr>
									<tr>
										<td style={{ textAlign: "center" }}>5</td>
										<td>National E- journals</td>
										<td style={{ textAlign: "center" }}>Institution subscribes ONOS Subscription</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="EResourcePanel" style={{
							background: "linear-gradient(135deg, #f0f8ff 0%, #e6f2ff 100%)",
							border: "1px solid #b3d4fc",
							borderRadius: "12px",
							padding: "2rem",
							textAlign: "center",
							boxShadow: "0 4px 15px rgba(0,0,0,0.05)"
						}}>
							<h3 style={{ marginBottom: "1rem", color: "#0056b3", fontSize: "1.5rem" }}>E-Resource Remote Access</h3>
							<p style={{ marginBottom: "1.5rem", color: "#333", fontSize: "1.1rem" }}>
								Access our electronic resources and journals remotely through the central library portal.
							</p>
							<a 
								href="https://library.vbu.ac.in/" 
								target="_blank" 
								rel="noopener noreferrer"
								style={{
									display: "inline-block",
									backgroundColor: "#0d6efd",
									color: "#fff",
									padding: "12px 25px",
									borderRadius: "6px",
									textDecoration: "none",
									fontWeight: "600",
									fontSize: "1.1rem",
									boxShadow: "0 4px 6px rgba(13, 110, 253, 0.2)",
									transition: "transform 0.2s, background-color 0.2s"
								}}
								onMouseOver={(e) => { e.target.style.backgroundColor = '#0b5ed7'; e.target.style.transform = 'translateY(-2px)' }}
								onMouseOut={(e) => { e.target.style.backgroundColor = '#0d6efd'; e.target.style.transform = 'translateY(0)' }}
							>
								Visit E-Resource Portal
							</a>
						</div>
					</div>

					<div className="PhotosSection">
						<div id="Secondary_Heading">
							<h3>Photos</h3>
						</div>

						<div className="PhotoContainer">
							<div className="PhotoRow">
								<div className="Img1">
									<img
										src="/Images/Campus/Dept/library-6.jpg"
										alt="imgdinner"
									/>
								</div>
								<div className="Img2">
									<img
										src="/Images/Campus/Dept/library-3.jpg"
										alt="imgdinner"
									/>
								</div>
							</div>
							<div className="PhotoRow">
								<div className="Img1">
									<img
										src="/Images/Campus/Dept/library-4.jpg"
										alt="imgdinner"
									/>
								</div>
								<div className="Img2">
									<img
										src="/Images/Campus/Dept/library-5.jpg"
										alt="imgdinner"
									/>
								</div>
							</div>
							<div className="PhotoRow">
								<div className="Img3">
									<img
										src="/Images/Campus/Dept/library-2.jpg"
										alt="imgdinner"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Library;
